export const DISABLE_BODY_SCROLL = "DISABLE_BODY_SCROLL";
export const ENABLE_BODY_SCROLL = "ENABLE_BODY_SCROLL";

const initialState = {
  bodyScrollEnabled: true
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DISABLE_BODY_SCROLL:
      return {
        ...state,
        bodyScrollEnabled: false
      };
    case ENABLE_BODY_SCROLL:
      return {
        ...state,
        bodyScrollEnabled: true
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./template/state/modules/bodyScroll/index.js